import { Outlet } from 'react-router-dom'
import { Logo } from './Logo'

/** Layout for the public registration pages (no navigation, brand-forward). */
export function PublicShell() {
  return (
    <div className="min-h-dvh bg-page">
      <div className="h-1.5 w-full bg-navy-900" />
      <header className="mx-auto flex w-full max-w-2xl items-center px-5 py-6">
        <Logo />
      </header>
      <main className="mx-auto w-full max-w-2xl px-5 pb-16">
        <Outlet />
      </main>
      <footer className="mx-auto w-full max-w-2xl px-5 pb-10 text-xs text-ink-500">
        Söderberg &amp; Partners · Regeringsgatan 45, 111 56 Stockholm · Personuppgifter behandlas enligt vår integritetspolicy.
      </footer>
    </div>
  )
}
